var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('h1',{staticClass:"text-light"},[_vm._v("(404) Page NotFound")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Go dashboard?")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }